import { ColDef } from 'ag-grid-community';
import { EstimatedTradeCostGridRow } from 'widgets/estimatedTradeCost/widget-comparison/components/grid/rows';
import { EstimatedTradeCostComparisonColumn } from 'widgets/estimatedTradeCost/widget-comparison/components/grid/columns';

export const setResultCellRenderer = (
    colDefs: ColDef<EstimatedTradeCostGridRow>[],
    field: EstimatedTradeCostComparisonColumn,
    onClickRefresh: () => void
) => {
    const colDef = colDefs.find((c) => c.field === field)!;
    colDef.cellRendererSelector = (params) => {
        const data = params.data!;

        if (data.isQuantityDirty) {
            return {
                component: 'needsRefresh',
                params: { onClickRefresh },
            };
        }
        if (data.zeroQuantity) {
            return { component: 'zeroQuantity' };
        }
        if (data.status === 'In Progress') {
            return { component: 'inProgress' };
        }

        if (data.status === 'Failed') {
            return { component: 'failed' };
        }
    };
};
